// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605120006/js/" + chunkId + "." + {"44":"5f16adce","225":"3fa08f02","481":"1622fc71","486":"734741e6","770":"81287fa6"}[chunkId] + ".0.07465780026508217.chunk.js";
};